var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,10c2.4,0,2.4,4.6,4.8,4.6c2.4,0,2.4-4.6,4.8-4.6c2.4,0,2.4,4.6,4.8,4.6c2.4,0,2.4-4.6,4.8-4.6 c2.4,0,2.4,4.6,4.8,4.6s2.4-4.6,4.8-4.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,20.6c2.4,0,2.4,4.6,4.8,4.6c2.4,0,2.4-4.6,4.8-4.6c2.4,0,2.4,4.6,4.8,4.6c2.4,0,2.4-4.6,4.8-4.6 c2.4,0,2.4,4.6,4.8,4.6s2.4-4.6,4.8-4.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrilling);
export default __webpack_public_path__ + "static/media/trilling.03ef9348eafe3eee4335b35c312852d3.svg";
export { ForwardRef as ReactComponent };